import BaseRepository from '@/core/standard/BaseRepository';
import {axiosInstance} from '@/setup/axios/AxiosConfig';
import {GenericMethod} from '@/core/Types/IRepository';

class RequestService extends BaseRepository {
  public collection = 'requests';
  public version = 'v1';

  public changeStatus(params: GenericMethod) {
    return this.request({...params, url: 'change_status'});
  }

  public print(params: GenericMethod) {
    return this.request({...params, url: 'print'});
  }

  public invalidate(params: GenericMethod) {
    return this.request({...params, url: 'invalidate'});
  }
  public retrieveReport(params: GenericMethod) {
    return this.request({...params, url: 'retrieve_report'});
  }

  public getClientOrUser(params: GenericMethod) {
    return this.request({...params, url: `get_client_or_user`});
  }

  public list(params: GenericMethod) {
    return this.request({...params, url: 'list'});
  }

  public get_by_screen(params: GenericMethod) {
    return this.request({...params, url: 'get_by_screen'});
  }

  public getDelivery(params: GenericMethod) {
    return this.request({...params, url: 'get_delivery'});
  }

  public acceptInvalidateOrder(params: GenericMethod) {
    return this.request({...params, url: 'accept'});
  }

  public mark(params: GenericMethod) {
    return this.request({...params, url: 'mark'});
  }

  public markOption(params: GenericMethod) {
    return this.request({...params, url: 'mark_option'});
  }

  public checkRequest(params: GenericMethod) {
    return this.request({...params, url: 'check_in_kitchen'});
  }

  public changeProcessStatus(params: GenericMethod) {
    return this.request({...params, url: 'change_process_status'});
  }

  public closeAllDomicilePickup(params: GenericMethod) {
    return this.request({...params, url: 'close_all_domicile_pickup'});
  }

  public sendTicketByEmailDomicilePickup(params: GenericMethod) {
    return this.request({...params, url: 'domicile_pickup_ticket_email'});
  }

  public assignDealer(params: GenericMethod) {
    return this.request({...params, url: 'assign_dealer', method: 'POST'});
  }
}

export default new RequestService(axiosInstance);
